import { render, staticRenderFns } from "./DHCPServers.vue?vue&type=template&id=3b94f322&scoped=true&"
import script from "./DHCPServers.vue?vue&type=script&lang=ts&"
export * from "./DHCPServers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b94f322",
  null
  
)

export default component.exports